module.exports = __webpack_public_path__ + "static/media/logoict.030ff182.png";